import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';

const KvhLogo = ({ width = '114px', height = '51px', className = '' }) => {
  return (
    <Icon name="kvh-logo-box" style={{ width, height }} className={className} />
  );
};

KvhLogo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default KvhLogo;
